import React, { useState } from 'react'

const S3Uploader = ({ accept, multiple, onProgress, onError, onFinish, signingUrl }) => {
  const [uploading, setUploading] = useState(false)

  const handleFileChange = async (event) => {
    const files = event.target.files
    if (!files.length) return

    setUploading(true)

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      
      try {
        // Get presigned URL
        const response = await fetch(signingUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            objectName: `${Date.now()}-${file.name}`,
            contentType: file.type
          })
        })

        if (!response.ok) {
          throw new Error('Failed to get presigned URL')
        }

        const { signedUrl, url } = await response.json()

        // Upload file to S3
        const uploadResponse = await fetch(signedUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type
          }
        })

        if (!uploadResponse.ok) {
          throw new Error('Failed to upload file')
        }

        // Call onFinish callback with S3 result
        if (onFinish) {
          // Extract bucket name and object key from the URL returned by server
          const bucketName = url.match(/https:\/\/([^.]+)\.s3/)?.[1] || 'atlastrailer-dev-tmp'
          const objectKey = url.split('/').pop() // Get the last part of the URL as the object key
          
          onFinish({
            location: url,
            bucket: bucketName,
            key: objectKey, // Use the actual object key from the server response
            etag: uploadResponse.headers.get('etag')
          }, file)
        }

      } catch (error) {
        console.error('Upload error:', error)
        if (onError) {
          onError(error)
        }
      }
    }

    setUploading(false)
    // Clear the input
    event.target.value = ''
  }

  return (
    <div>
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileChange}
        disabled={uploading}
      />
      {uploading && <p>Uploading...</p>}
    </div>
  )
}

export default S3Uploader
